<div class="modal">
  <div class="close-link">
    <span class="close" (click)="onCloseClick()"></span>
  </div>
  <h1 class="modal__title">{{ 'pages.tables.modal.titleCallWaiter' | translate }}</h1>
  <form class="modal__form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-checkbox
      formControlName="allOn"
      color="primary"
      class="parentCheckbox"
      [indeterminate]="someOn()"
    >
      {{ 'pages.tables.modal.selectAll' | translate }}
    </mat-checkbox>
    <div class="group_wrapper">
      <div
        formGroupName="main"
        class="group"
      >
        <div class="group__header">{{ 'pages.tables.modal.callWaiterMain' | translate }}</div>
        <mat-checkbox formControlName="enabled" color="primary" class="group__toggle">
          {{ 'pages.widget.form.callWaiterButtons.callWaiter.enable' | translate }}
        </mat-checkbox>
        <mat-form-field
          class="group__field login-wrap__text generated-name"
          [matTooltip]="'pages.tables.modal.sysNameInfo' | translate"
          matTooltipPosition="right"
        >
          <mat-label>
            {{ 'pages.tables.modal.systemName' | translate }}
          </mat-label>
          <input class="call_name" matInput appFormInputTrim formControlName="name">
        </mat-form-field>
        <div class="translations" formArrayName="translations">
          <fieldset
            class="translation"
            *ngFor="let translation of getTranslationsControls('main'); let i = index"
            [formGroupName]="i"
          >
              <legend class="translation__language">{{ 'pages.tables.modal.language' | translate }} {{ getTranslationLanguageLabel(translation) }}</legend>
              <mat-form-field class="translation__value login-wrap__text">
                <mat-label>
                  {{ 'pages.tables.modal.translation' | translate }}
                  <span class="default">{{ 'pages.tables.modal.default' | translate }} "{{ getDefaultTranslationLabel('main', translation) }}"</span>
                </mat-label>
                <input matInput appFormInputTrim formControlName="value">
              </mat-form-field>
              <button
                class="btn btn-delete__small translation__remove"
                type="button"
                *ngIf="i > 0"
                (click)="removeTranslation('main', i)"
              >
                <mat-icon color="warn">delete</mat-icon>
              </button>
          </fieldset>
        </div>
        <button
          class="btn add-language-btn"
          type="button"
          [disabled]="!form.get('main.enabled')?.value || !canAddFrenchTranslation('main')"
          (click)="addTranslation('main')"
        >
          <mat-icon>add</mat-icon>
          {{ 'pages.tables.modal.addTranslation' | translate }}
        </button>
      </div>
      <div
        formGroupName="secondary"
        class="group"
      >
        <div class="group__header">{{ 'pages.tables.modal.callWaiterSecondary' | translate }}</div>
        <mat-checkbox formControlName="enabled" color="primary" class="group__toggle">
          {{ 'pages.widget.form.callWaiterButtons.anotherRound.enable' | translate }}
        </mat-checkbox>
        <mat-form-field
          class="group__field login-wrap__text generated-name"
          [matTooltip]="'pages.tables.modal.sysNameInfo' | translate"
          matTooltipPosition="right"
        >
          <mat-label>
            {{ 'pages.tables.modal.systemName' | translate }}
          </mat-label>
          <input class="call_name" matInput appFormInputTrim formControlName="name">
        </mat-form-field>
        <div class="translations" formArrayName="translations">
          <fieldset
            class="translation"
            *ngFor="let translation of getTranslationsControls('secondary'); let i = index"
            [formGroupName]="i"
          >
            <legend class="translation__language">{{ 'pages.tables.modal.language' | translate }} {{ getTranslationLanguageLabel(translation) }}</legend>
            <mat-form-field class="translation__value login-wrap__text">
              <mat-label>
                {{ 'pages.tables.modal.translation' | translate }}
                <span class="default">{{ 'pages.tables.modal.default' | translate }} "{{ getDefaultTranslationLabel('secondary', translation) }}"</span>
              </mat-label>
              <input matInput appFormInputTrim formControlName="value">
            </mat-form-field>
            <button
              class="btn btn-delete__small translation__remove"
              type="button"
              *ngIf="i > 0"
              (click)="removeTranslation('secondary', i)"
            >
              <mat-icon color="warn">delete</mat-icon>
            </button>
          </fieldset>
        </div>
        <button
          class="btn add-language-btn"
          type="button"
          [disabled]="!form.get('secondary.enabled')?.value || !canAddFrenchTranslation('secondary')"
          (click)="addTranslation('secondary')"
        >
          <mat-icon>add</mat-icon>
          {{ 'pages.tables.modal.addTranslation' | translate }}
        </button>
      </div>
      <div
        formGroupName="tertiary"
        class="group"
        [ngClass]="{'active': this.form.get('tertiary.enabled')?.value, 'inactive': !this.form.get('tertiary.enabled')?.value}"
      >
        <div class="group__header">{{ 'pages.tables.modal.callWaiterTertiary' | translate }}</div>
        <mat-checkbox formControlName="enabled" color="primary" class="group__toggle">
          {{ 'pages.widget.form.callWaiterButtons.requestBill.enable' | translate }}
        </mat-checkbox>
        <mat-form-field
          class="group__field login-wrap__text generated-name"
          [matTooltip]="'pages.tables.modal.sysNameInfo' | translate"
          matTooltipPosition="right"
        >
          <mat-label>
            {{ 'pages.tables.modal.systemName' | translate }}
          </mat-label>
          <input class="call_name" matInput appFormInputTrim formControlName="name">
        </mat-form-field>
        <div class="translations" formArrayName="translations">
          <fieldset
            class="translation"
            *ngFor="let translation of getTranslationsControls('tertiary'); let i = index"
            [formGroupName]="i"
          >
            <legend class="translation__language">{{ 'pages.tables.modal.language' | translate }} {{ getTranslationLanguageLabel(translation) }}</legend>
            <mat-form-field class="translation__value login-wrap__text">
              <mat-label>
                {{ 'pages.tables.modal.translation' | translate }}
                <span class="default">{{ 'pages.tables.modal.default' | translate }} "{{ getDefaultTranslationLabel('tertiary', translation) }}"</span>
              </mat-label>
              <input matInput appFormInputTrim formControlName="value">
            </mat-form-field>
            <button
              class="btn btn-delete__small translation__remove"
              type="button"
              *ngIf="i > 0"
              (click)="removeTranslation('tertiary', i)"
            >
              <mat-icon color="warn">delete</mat-icon>
            </button>
          </fieldset>
        </div>
        <button
          class="btn add-language-btn"
          type="button"
          [disabled]="!form.get('tertiary.enabled')?.value || !canAddFrenchTranslation('tertiary')"
          (click)="addTranslation('tertiary')"
        >
          <mat-icon>add</mat-icon>
          {{ 'pages.tables.modal.addTranslation' | translate }}
        </button>
      </div>
    </div>
    <div class="modal__submit-btn">
      <button class="btn btn__primary" type="submit" [disabled]="!hasUnsavedChanges || !form.valid">
        {{ 'pages.tables.modal.save' | translate }}
      </button>
    </div>
  </form>
</div>
